import { Button, Sprite, SpriteFrame, _decorator } from 'cc';
import ButtonStateEffect from './ButtonStateEffect';

const { ccclass, property, requireComponent, menu } = _decorator;

@ccclass('ButtonSpriteEffect')
@requireComponent(Sprite)
@menu('ButtonStateEffect/ButtonSpriteEffect')
export default class ButtonSpriteEffect extends ButtonStateEffect<Sprite> {
    @property({ type: SpriteFrame, formerlySerializedAs: 'normalSpriteFrame' })
    private _normalSpriteFrame: SpriteFrame = null;

    @property({ type: SpriteFrame, formerlySerializedAs: 'pressedSpriteFrame' })
    private _pressedSpriteFrame: SpriteFrame = null;

    @property({ type: SpriteFrame, formerlySerializedAs: 'hoverSpriteFrame' })
    private _hoverSpriteFrame: SpriteFrame = null;

    @property({ type: SpriteFrame, formerlySerializedAs: 'disabledSpriteFrame' })
    private _disabledSpriteFrame: SpriteFrame = null;

    @property(SpriteFrame)
    public get normalSpriteFrame() {
        return this._normalSpriteFrame;
    }
    public set normalSpriteFrame(value: SpriteFrame) {
        if (value === this._normalSpriteFrame) {
            return;
        }
        this._normalSpriteFrame = value;
        this.syncState();
    }

    @property(SpriteFrame)
    public get pressedSpriteFrame() {
        return this._pressedSpriteFrame;
    }
    public set pressedSpriteFrame(value: SpriteFrame) {
        if (value === this._pressedSpriteFrame) {
            return;
        }
        this._pressedSpriteFrame = value;
        this.syncState();
    }

    @property(SpriteFrame)
    public get hoverSpriteFrame() {
        return this._hoverSpriteFrame;
    }
    public set hoverSpriteFrame(value: SpriteFrame) {
        if (value === this._hoverSpriteFrame) {
            return;
        }
        this._hoverSpriteFrame = value;
        this.syncState();
    }

    @property(SpriteFrame)
    public get disabledSpriteFrame() {
        return this._disabledSpriteFrame;
    }
    public set disabledSpriteFrame(value: SpriteFrame) {
        if (value === this._disabledSpriteFrame) {
            return;
        }
        this._disabledSpriteFrame = value;
        this.syncState();
    }

    protected getEffectTarget() {
        return this.getComponent(Sprite);
    }

    protected updateState(state: Button.State) {
        const spriteFrameMap: { [state in Button.State]: SpriteFrame } = {
            [Button.State.NORMAL]: this.normalSpriteFrame,
            [Button.State.PRESSED]: this.pressedSpriteFrame,
            [Button.State.HOVER]: this.hoverSpriteFrame ?? this.normalSpriteFrame,
            [Button.State.DISABLED]: this.disabledSpriteFrame,
        };
        this.effectTarget.spriteFrame = spriteFrameMap[state];
    }
}
